module.exports = __webpack_public_path__ + "img/habits.c1b80f9e.svg";